import { colors } from '@karnott/colors';
import CircledIcon from '../utils/circledIcon';

export const CanBusTextIcon = ({ color = '#000', size = 30, backgroundColor = colors('grey'), circled = false }) => (
  <CircledIcon {...{ backgroundColor, circled }} size={size * 2} height={size}>
    <svg
      width={circled ? '50%' : '100%'}
      height={circled ? '50%' : '100%'}
      viewBox="0 0 49 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g fill="none">
        <path
          d="M22.6883 15.026C21.9091 14.6364 21.3896 14.1169 20.8701 13.3377C20.4805 12.6883 20.2208 11.7792 20.2208 10.8701C20.2208 9.96104 20.4805 9.18182 20.8701 8.4026C21.2597 7.75324 21.9091 7.10389 22.6883 6.71428C23.4675 6.32467 24.2468 6.06493 25.1558 6.06493C26.0649 6.06493 26.7143 6.1948 27.2338 6.45454C27.8831 6.71428 28.4026 7.10389 28.7922 7.62337L27.4935 8.92208C26.8442 8.27272 26.0649 7.88312 25.1558 7.88312C24.2468 7.88312 24.1169 7.88311 23.5974 8.27272C23.2078 8.53246 22.8182 8.92208 22.5584 9.31169C22.2987 9.7013 22.1688 10.2208 22.1688 10.8701C22.1688 11.5195 22.1688 11.9091 22.5584 12.4286C22.9481 12.9481 23.2078 13.2078 23.5974 13.4675C23.987 13.7273 24.5065 13.8571 25.1558 13.8571C26.0649 13.8571 26.8442 13.4675 27.4935 12.8182L28.7922 14.1169C28.4026 14.6364 27.8831 15.026 27.2338 15.2857C26.5844 15.5455 25.9351 15.6753 25.1558 15.6753C24.3766 15.6753 23.3377 15.4156 22.6883 15.026Z"
          fill={color}
        />
        <path
          d="M36.0649 13.5974H31.9091L31.1299 15.5455H28.9221L32.9481 6.45455H35.026L39.052 15.5455H36.8442L36.0649 13.5974ZM35.4156 11.9091L33.987 8.4026L32.5585 11.9091H35.4156Z"
          fill={color}
        />
        <path
          d="M48.4026 6.45455V15.5455H46.7143L42.1688 10.0909V15.5455H40.0909V6.45455H41.7792L46.3247 11.9091V6.45455H48.4026Z"
          fill={color}
        />
        <path
          d="M0.610382 17.3636C0.610382 19.3117 2.16882 20.8701 4.11688 20.8701C5.54545 20.8701 6.97402 19.961 7.4935 18.5325"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.36363 18.6623C7.4935 18.2727 7.62337 17.8831 7.62337 17.3636C7.62337 15.4156 5.93506 13.987 3.98701 13.987C2.16882 13.987 0.740252 15.5455 0.610382 17.2338"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12.4286 21C13.7196 21 14.7662 19.9534 14.7662 18.6623C14.7662 17.3713 13.7196 16.3247 12.4286 16.3247C11.1375 16.3247 10.0909 17.3713 10.0909 18.6623C10.0909 19.9534 11.1375 21 12.4286 21Z"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.18182 13.0779L6.19481 14.5065"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.18183 13.0779L8.14287 9.05194H2.29871C2.03897 9.05194 1.9091 9.18181 1.9091 9.44155V14.2467"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M0.610382 17.3636C0.610382 19.3117 2.16882 20.8701 4.11688 20.8701C5.54545 20.8701 6.97402 19.961 7.4935 18.5325H10.2208C10.2208 19.8312 11.1299 20.8701 12.4286 20.8701C13.7273 20.8701 14.7662 19.961 14.7662 18.6623V13.987C14.7662 13.4675 14.3766 13.0779 13.8571 13.0779H9.31168"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path d="M3.72726 5.54545V1" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
        <path
          d="M5.02597 4.37662L3.72726 5.67532"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M2.42856 4.37662L3.72726 5.67532"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.27272 1.25975V5.67533"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M6.97401 2.42857L8.27272 1"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M9.57142 2.42857L8.27272 1"
          stroke={color}
          strokeWidth="1.2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  </CircledIcon>
);
